import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNaverCafe = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "4 4 24 24",
	id: "aside_cafe_logo",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "none",
			rx: 16
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M16.16 12.025H11.68c.12-2.476 2.182-4.447 4.708-4.447h4.482c-.12 2.477-2.182 4.447-4.709 4.447z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M8.211 14.545c0-.483.393-.876.876-.876h12.439c.484 0 .876.393.876.876V18.4a7.095 7.095 0 11-14.19 0v-3.854z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeWidth: 1.263,
			d: "M21.852 14.3h1.34a2.916 2.916 0 010 5.833h-1.34V14.3z"
		})
	]
});
export default SvgNaverCafe;
